import template from './short-form-object-preview.jade';

export default angular
  .module('cian.addForm.aboutBuildingShortFormObjectPreview', [])
  .directive('cianAfAboutBuildingShortFormObjectPreview', [function () {
    return {
      scope: {},
      controller: ['addFormService', 'simpleFormService', function (addFormService, simpleFormService) {
        this.ad = addFormService.ad;
        this.heading = this.ad.geo.userInput;
        this.year = this.ad.building.buildYear;
        this.floors = this.ad.building.floorsCount;
        this.passengerLifts = this.ad.building.passengerLiftsCount || 'нет';
        this.cargoLifts = this.ad.building.cargoLiftsCount || 'нет';

        this.handleClickOnButton = simpleFormService.showAboutBuildingFields;
      }],
      controllerAs: 'c',
      template,
    }
  }])
  .name;
